module.exports = __webpack_public_path__ + "assets/af4d238104214cae3db1f757c663f7af.mp3";